module.exports = __webpack_public_path__ + "static/014-ec8b465640f1e2f207cf46cea6a40abc.jpg";